/** Display label for SPD chapters from GET /api/spds (name + optional abbreviation). */
export function formatSpdLabel(spd: {
  name?: string;
  abbreviation?: string | null;
}): string {
  const name = (spd.name ?? '').trim();
  const abbr = (spd.abbreviation ?? '').trim();
  if (!name) return abbr;
  if (!abbr) return name;
  return `${name} (${abbr})`;
}
